import { render, staticRenderFns } from "./TransactionsListsFilters.vue?vue&type=template&id=2b056533&"
import script from "./TransactionsListsFilters.vue?vue&type=script&lang=js&"
export * from "./TransactionsListsFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports